import API from "../../api";

export default function LanguageSettings() {
  

  const changeLanguage = async (lang) => {
  // Save locally
  localStorage.setItem("civilink_lang", lang);

  // Save to backend
  try {
    await API.put("/users/language", {
      language: lang
    });
  } catch {
    // Silent fail
  }

  // Reload app
  window.location.reload();
};

  return (
    <section className="settings-card">
      <div className="card-header">
        <h3>Language</h3>
        <p>Choose your preferred language</p>
      </div>

      <div className="option-row">
        <button onClick={() => changeLanguage("en")}>English</button>
        <button onClick={() => changeLanguage("ta")}>தமிழ்</button>
        <button onClick={() => changeLanguage("hi")}>हिंदी</button>
      </div>
    </section>
  );
}
